import { absolutePath } from "./absolutePath";

interface Params {
  params?: Record<string, unknown>;
}

export const billingDetails = {
  show: ({ params = {} }: Params = {}) =>
    absolutePath("billing_details", params),
  update: ({ params = {} }: Params = {}) =>
    absolutePath("billing_details", params),
};
